import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { IClauseExtensionMySuffix } from 'src/app/shared/model/clause-extension-my-suffix.model';
import { ClauseExtensionMySuffixService } from './clause-extension-my-suffix.service';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

import { ConfirmationModelService } from 'src/app/shared/confirmation-modal/confirmation-model.service';
import { FutureDataType } from 'src/app/shared/model/future_data_type.model';

@Component({
    selector: 'jhi-clause-extension-my-suffix-delete-dialog',
    templateUrl: './clause-extension-my-suffix-delete-dialog.component.html'
})
export class ClauseExtensionMySuffixDeleteDialogComponent {
    clauseExtension: IClauseExtensionMySuffix;
    futureStatus: boolean = false;
    isConfirmed: boolean = false;

    constructor(
        private clauseExtensionService: ClauseExtensionMySuffixService,
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager,
        private futureRecordService: ConfirmationModelService,
        private languageChangeService: LanguageChangeService,
        private activatedRoute: ActivatedRoute

    ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    setFutureStatus(futureStatus) {
        this.futureStatus = futureStatus;
    }

    confirmDelete(id: number) {
        this.isConfirmed = true;
        if (this.futureStatus) {
            this.updateExistedFutureRecordStatus(id);
        }
        this.clauseExtensionService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'clauseExtensionListModification',
                content: 'Deleted an clauseExtension'
            });
            this.activeModal.dismiss(true);
        });
    }

    updateExistedFutureRecordStatus(id: number) {
        this.futureRecordService.updateExistedFutureRecordStatus({
            masterId: this.clauseExtension.id,
            futureDataType: FutureDataType.CLAUSE_EXTENSION.valueOf(),
            fromEffectiveDateFormatted: this.clauseExtension.fromEffectiveDate,
            masterStatus : this.clauseExtension.activeStatus == 'ACTIVE' ? 'IN_ACTIVE' : 'ACTIVE',
        }).subscribe(response => {
            console.log(response.body);
        });
    }
}

@Component({
    selector: 'jhi-clause-extension-my-suffix-delete-popup',
    template: ''
})
export class ClauseExtensionMySuffixDeletePopupComponent implements OnInit, OnDestroy {
    private ngbModalRef: NgbModalRef;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal,
    ) {}

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ clauseExtension }) => {
            setTimeout(() => {
                this.ngbModalRef = this.modalService.open(ClauseExtensionMySuffixDeleteDialogComponent as Component, {
                    size: 'lg',
                    backdrop: 'static'
                });
                this.ngbModalRef.componentInstance.clauseExtension = clauseExtension;
                this.ngbModalRef.result.then(
                    result => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/clause-extension']));
                        this.ngbModalRef = null;
                    },
                    reason => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/clause-extension']));
                        this.ngbModalRef = null;
                    }
                );
            }, 0);
        });
    }

    ngOnDestroy() {
        this.ngbModalRef = null;
    }
}
